import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface usersstate {
  data: any[];
  count: number;
}

const initialState: usersstate = {
  data: [],
  count: 0,
};

export const usersslice = createSlice({
  name: "users",
  initialState,
  reducers: {
    saveusersData: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.data = payload?.data;
      state.count = payload?.count;
    },
    addusersRedux: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.data.unshift(payload);
      state.count += 1;
    },
    editusersRedux: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.data.splice(payload?.index, 1, payload?.data);
    },
    deleteusersRedux: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.data.splice(payload?.index, 1);
      state.count -= 1;
    },
  },
});

export const { saveusersData, addusersRedux, editusersRedux, deleteusersRedux } = usersslice.actions;

export default usersslice.reducer;
